<script setup lang="ts">
onMounted(async () => {
  await useTealium()
})
</script>

<template>
  <div>
    <VoixSiteAuth>
      <VoixPage>
        <VoixRoot />
      </VoixPage>
    </VoixSiteAuth>
  </div>
</template>
